import { Link } from 'react-router-dom';

import { useTranslation } from '../shared/i18n/useTranslation';

export function NotFoundPage() {
  const { t } = useTranslation();
  return (
    <main
      role="alert"
      className="mx-auto flex min-h-screen max-w-xl flex-col justify-center gap-4 p-6"
    >
      <h1 className="text-3xl font-bold text-fg-DEFAULT">{t('error.404.title')}</h1>
      <p className="text-fg-muted">{t('error.404.description')}</p>
      <Link
        to="/"
        className="inline-flex min-h-[48px] w-fit items-center rounded-lg bg-brand-800 px-5 font-medium text-white"
      >
        {t('common.back')}
      </Link>
    </main>
  );
}
